import { Alert, Clickable, LoadingPageContent, Wrapper } from '@ahmdigital/ui';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client/react';

import { GET_SERVICES } from './query.gql';
import { RootState } from '../../../../reducers';
import { Service } from '../../../../types/__codegen__/ahm-api/graphql';
import { URLS } from '../../../../models/url/constants';
import BuildYourCoverActions, { BuildYourCoverProductType } from '../../../../actions/build-your-cover';
import client from '../../../../graphql/client';
import logger from '../../../../logging';
import selectBuildYourCover from '../../../../selectors/select-build-your-cover';
import selectCustomer from '../../../../selectors/select-customer';
import ServiceSelection from '../components/service-selection';

const headings = {
  extras: {
    subtitle: 'See our commonly chosen inclusions below or view the whole list.',
    title: 'Extras',
  },
  hospital: {
    subtitle: 'See our commonly chosen inclusions below or view the whole list.',
    title: 'Hospital',
  },
};

const ServiceSelectionWithDataLoader = ({ productType }: { productType: BuildYourCoverProductType }) => {
  const dispatch = useDispatch();
  const selectedServicesFromState = useSelector(
    (state: RootState) => selectBuildYourCover(state)?.selectedServices?.[productType],
  );

  const dob = useSelector(selectCustomer)?.members[0]?.dob;
  const setSelectedServices = (selectedServices: Service['serviceId'][]) => {
    BuildYourCoverActions.setSelectedServices(productType, selectedServices)(dispatch);
  };

  const { data, error, loading } = useQuery(GET_SERVICES, {
    client,
    variables: { input: { dob, productType } },
  });

  if (loading) {
    return <LoadingPageContent />;
  }

  if (!data?.getServices) {
    logger.getLogger().error('No data returned from GetServices query', { dob, error, productType });
    return (
      <Wrapper size="large">
        <Alert heading="Unable to load services" level="danger">
          We couldn’t load this page at the moment. A quick refresh might help, and if you’re still having trouble, you
          can continue by browsing <Clickable to={URLS.SALES.PRODUCT_LISTING_HOSPITAL}>hospital cover</Clickable> or{' '}
          <Clickable to={URLS.SALES.PRODUCT_LISTING_EXTRAS}>extras cover</Clickable> products.
        </Alert>
      </Wrapper>
    );
  }

  return (
    <ServiceSelection
      {...headings[productType]}
      selectedServices={selectedServicesFromState}
      serviceList={data.getServices}
      setSelectedServices={setSelectedServices}
    />
  );
};

export default ServiceSelectionWithDataLoader;
